/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Intelligence_DescriptionInputs */



/**
* | output |
* | --- |
* | "A weekly readout of what changed in your Discord server and why, findings worth acting on, and the measured effect of every event." |
*
* @param {Meta_Intelligence_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const meta_intelligence_description = /** @type {((inputs?: Meta_Intelligence_DescriptionInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Intelligence_DescriptionInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Еженедельная сводка о том, что изменилось на вашем сервере Discord и почему, находки, на которые стоит обратить внимание, и измеренный эффект каждого события.")
	return /** @type {LocalizedString} */ ("A weekly readout of what changed in your Discord server and why, findings worth acting on, and the measured effect of every event.")
});